import {
  StepProps,
  type StepMap,
} from "@/components/onboarding/components/welcome-wizard/welcome-wizard.types";
import {
  FooterContainer,
  FooterNextButton,
  FooterSkipButton,
  StepTitle,
  StyledStepTitleWrapper,
  WizardContentWrapper,
} from "@/components/onboarding/components/welcome-wizard/welcome-wizard.styles";
import { DropTargetStep } from "./drop-target-step";
import { StepGroups } from "@/components/onboarding/components/welcome-wizard/welcome-wizard.config";
import { StepContentWithTabs } from "@/components/onboarding/components/welcome-wizard/tabs";
import { MDSTextWeight, MDSTextVariant, MDSText, MDSIconButton, MDSIconKind } from "@/mds";

const ObsidianStep: React.FC<StepProps> = ({
  onNavToStep,
  onSkip,
  handleTabSelect,
  onClose,
  context,
}) => (
  <WizardContentWrapper>
    <StyledStepTitleWrapper>
      <StepTitle>Import Notes</StepTitle>
      {context.wizardType === "import" && (
        <MDSIconButton iconKind={MDSIconKind.Exit} onClick={onClose} />
      )}
    </StyledStepTitleWrapper>
    <StepContentWithTabs
      selectedAppId={context?.selectedAppId || null}
      onAppSelect={handleTabSelect}
      tabConfig={StepGroups["IMPORT"].tabConfig}
    >
      <MDSText variant={MDSTextVariant.ParagraphSm} weight={MDSTextWeight.Regular}>
        Bring in your Obsidian notes so you can find them with Mem Search, Chat, and Heads Up
      </MDSText>
      <DropTargetStep
        onDrop={() => {
          if (context.wizardType === "welcome") onNavToStep?.("download-apps");
          if (context.wizardType === "import") onClose?.();
        }}
      />
    </StepContentWithTabs>
    {context.wizardType === "welcome" && (
      <FooterContainer align="space-between">
        <FooterSkipButton onClick={onSkip}>Skip for now</FooterSkipButton>
        <FooterNextButton onClick={() => onNavToStep?.("download-apps")}>
          Next step
        </FooterNextButton>
      </FooterContainer>
    )}
  </WizardContentWrapper>
);

export const ObsidianStepsMap: StepMap = {
  "obsidian-1": {
    id: "obsidian-1",
    group: "import-cta",
    render: ({ onNavToStep, onSkip, handleTabSelect, onClose, context }) => (
      <ObsidianStep
        onNavToStep={onNavToStep}
        onSkip={onSkip}
        handleTabSelect={handleTabSelect}
        onClose={onClose}
        context={context}
      />
    ),
  },
};
